<template>
  <v-dialog v-model="dialog" max-width="1200px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("ReturnOrder.import_err_title") }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          {{ $t("$vuetify.close") }}
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-4 py-8 text-center subtitle-1">
        <v-data-table
          :headers="headers"
          :items="importResultErr"
          multi-sort
          class="elevation-1 px-4 pt-2"
          disable-pagination
          hide-default-footer
          fixed-header
        >
          <template v-slot:item.shop_code="{ item }">
            <span class="text-no-wrap">
              {{ item.shop_name }}
            </span>
            <br />
            <span class="text-no-wrap caption secondary--text">
              {{ item.shop_code }}
            </span>
          </template>
          <template v-slot:item.material_code="{ item }">
            {{ item.material_code + "/" + item.material_name }}
          </template>
          <template v-slot:item.error_msg="{ item }">
            <span class="red--text">
              {{ item.error_msg }}
            </span>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" outlined   @click="$emit('cancel');dialog = false;">
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn color="primary" depressed :href="reportUrl">
          {{ $t("ReturnOrder.report_download_record") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";

export default {
  name: "DialogImportResult",

  props: {
    value: Boolean,
    fullField: Boolean,
    importResultErr: Array,
    reportUrl: String,
  },

  components: {
  },

  computed: {
    headers() {
      return [
        {
          text: i18n.t("ReturnOrder.Fields.account_id"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "account_id",
        },
        {
          text: i18n.t("ReturnOrder.Fields.order_code"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "order_code",
        },
        {
          text: i18n.t("ReturnOrder.Fields.shop"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "shop_code",
        },
        {
          text: i18n.t("ReturnOrder.Fields.material"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "material_code",
        },
        {
          text: i18n.t("ReturnOrder.Fields.price"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "price",
        },
        {
          text: i18n.t("ReturnOrder.Fields.apply_num"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "apply_num",
        },
        {
          text: i18n.t("ReturnOrder.Fields.error_msg"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "error_msg",
        },
      ];
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  data: () => ({
    dialog: false,
  }),

  methods: {

  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.dialog = this.value;
        }
      },
    },
  },
};
</script>